/**
 * The site's identity, with no dependencies.
 *
 * Its own module so the page registry (`config/seo.ts`), the structured-data
 * builders (`config/structuredData.ts`) and the DOM writer (`utils/seo.ts`) can
 * all import it without importing each other: the registry needs the builders,
 * and the writer needs the registry, so the constants cannot live in either.
 */

/**
 * Canonical origin. Deliberately a constant rather than `window.location.origin`:
 * staging serves the same pages from test.weareqa.com, and its canonical has to
 * point at production or the two compete for the same queries.
 */
export const SITE_URL = 'https://weareqa.com';

/**
 * The one `@id` for the company in every JSON-LD block on the site. Every node
 * that means "WeAreQA" -- a Service's provider, a Person's employer, a
 * WebSite's publisher -- points here, and only `organizationJsonLd()` defines it.
 */
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
